import { ApiEndpoint } from './ApiDefinition';

export type Dashboard = {
    id: number,
    uuid: string,
    name: string,
    thumbnailUrl: string,
}

export type DashboardEmbedToken = {
  url: string,
  token: string,
  embeddedId: string,  // camelCase to match backend C# serialization
}

const ReportsApi = {
  getReportsBackendUrl: ApiEndpoint<void, string>({
    url: 'manage/reports/backend-url',
  }),
  listDashboards: ApiEndpoint<void, Dashboard[]>({
    url: 'manage/reports/dashboards/list',
  }),
  getDashboardEmbedToken: ApiEndpoint<{dashboardUuid: string, constraints?: { dataset: number, clause: string }[]}, DashboardEmbedToken>({
    url: ({
      dashboardUuid
    }) => `manage/reports/dashboards/${dashboardUuid}/token`,
    method: 'post',
    body: ({ constraints }) => constraints ?? [],
  }),
};

export default ReportsApi;
